/* @flow */
import moment from 'moment';

import Td from 'components/UIKit/Table/Td';
import ParamsLink from 'components/Links/ParamsLink';
import TrLink from '../TrLink';

type CasesRowProps = {
  router: Object,
  children: any,
}

export default function CasesRow({
  children, router,
}: CasesRowProps): React.Element {
  const newQuery = { did: children.id };
  const isActiveItem = children.id
    && (router.location.query.did === children.id);

  return (
    <TrLink
      isActiveItem={isActiveItem}
      linkId={children.id}
      router={router}
      >
      <Td >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isActiveItem ? children.submitter_id : (
            <ParamsLink customDataTestID="text-submiter-id" query={newQuery}>
              { children.submitter_id }
            </ParamsLink>
          )}
        </div>
      </Td>
      <Td style={{ textTransform: 'capitalize' }}>{ children.state }</Td>
      <Td customDataTestID="text-last-updated" >{ moment(children.updated_datetime).format('ll') }</Td>
    </TrLink>
  );
}
